import React from "react";
import TopBar from "@/components/TopBar";
import HomeHero from "@/components/HomeHero";

export default function HomePage() {
  return (
    <div>
      <TopBar />
      <HomeHero />
    </div>
  );
}
